// extracted by mini-css-extract-plugin
export default {"head":"FaqsTutorialsHead_head__5ew6M","links_holder":"FaqsTutorialsHead_links_holder__KhgFv","link":"FaqsTutorialsHead_link__GWoRq"};